import {
  AuthActionTypes,
  AuthState,
  USER_PROFILE,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  SETTINGS,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  LOGIN_SUCCESS,
  GET_CURRENT_LOCATION,
  LOGIN_FAILURE,
  REGISTER_SUCCESS,
  LOGOUT,
  RESET_AUTH_STATE,
  REGISTER,
  REGISTER_FAILURE,
  PASSWORD_AUTHENTICATE,
  PASSWORD_AUTHENTICATE_SUCCESS,
  RESET_PASSWORD_AUTHENTICATE,
  PASSWORD_AUTHENTICATE_FAILURE,
} from "../types/authTypes";

const initialState: AuthState = {
  success: null,
  user: [],
  location_address: null,
  error: null,
  loading: false,
  systemSettings: [],
  passwordAuthenticate: false,
};

export const authReducer = (
  state = initialState,
  action: AuthActionTypes
): AuthState => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        success: action.payload?.message,
        user: action.payload?.user,
        error: null,
        loading: false,
      };
    }

    case REGISTER: {
      return { ...state, loading: true, success: null };
    }

    case REGISTER_SUCCESS: {
      return {
        ...state,
        success: action.payload?.message,
        error: null,
        loading: false,
      };
    }

    case LOGIN_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }

    case REGISTER_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }

    case GET_CURRENT_LOCATION: {
      return { ...state, location_address: action.payload, loading: false };
    }

    case CHANGE_PASSWORD: {
      return { ...state, loading: false };
    }

    case CHANGE_PASSWORD_SUCCESS: {
      return { ...state, success: action.payload?.message, loading: false };
    }
    case CHANGE_PASSWORD_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }

    case RESET_PASSWORD: {
      return { ...state, loading: false };
    }

    case RESET_PASSWORD_SUCCESS: {
      return { ...state, loading: false };
    }
    case RESET_PASSWORD_FAILURE: {
      return { ...state, loading: false };
    }

    case USER_PROFILE: {
      return { ...state, success: null, loading: true };
    }

    case USER_PROFILE_SUCCESS: {
      return { ...state, user: action.payload?.data, loading: false };
    }

    case USER_PROFILE_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }

    case SETTINGS: {
      return { ...state, loading: true, systemSettings: [] };
    }

    case SETTINGS_SUCCESS: {
      return { ...state, systemSettings: action.payload?.data, loading: false };
    }

    case SETTINGS_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }

    case LOGOUT:
      return {
        ...state,
        location_address: "",
        success: null,
        user: null,
        error: null,
      };

    case PASSWORD_AUTHENTICATE: {
      return { ...state, passwordAuthenticate: false, error: null };
    }

    case PASSWORD_AUTHENTICATE_SUCCESS: {
      return { ...state, passwordAuthenticate: true, error: null };
    }

    case PASSWORD_AUTHENTICATE_FAILURE: {
      return { ...state, passwordAuthenticate: false, error: action.payload };
    }

    case RESET_PASSWORD_AUTHENTICATE: {
      return { ...state, passwordAuthenticate: false };
    }

    case RESET_AUTH_STATE: {
      return {
        ...state,
        location_address: "",
        success: null,
        error: null,
        loading: false,
      };
    }

    default:
      return state;
  }
};
